// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebarTabs_sidebar__I-P2P","tab":"sidebarTabs_tab__AKS13","active":"sidebarTabs_active__J1fOA"};